module.exports = __webpack_public_path__ + "static/media/spin.74e1c3ee.svg";